import { apiPost, generateFormData, apiStore } from '../../../modules/apiHelper';
import { toBoolean } from '../../../modules/dataHelper';

export default {
  async getUserGoals(context) {
    const formData = generateFormData({
      userid: context.state.id,
    });

    const userType = context.state.type;
    const { userTypeName } = context.getters;

    // ! needs to be one. ERROR!!!
    const apiCall = (userType === 3)
      ? apiPost('goals_check', formData)
      : apiPost('sub_goals_check', formData, 1);

    const goals = await apiCall
      .catch((err) => {
        console.warn('getUserGoals\nCannot get user goals\n', err);
        return [];
      })
      .then(async (res) => {
        if (!res) return [];
        if (toBoolean(res.data.error)) return [];

        const userGoals = res.data.goals_check || [];
        const addUserGoalMutationName = userType === 3
          ? 'addMentorGoal'
          : 'addMenteeGoal';

        userGoals.forEach((goal) => {
          context.commit(addUserGoalMutationName, goal.ementid);
        });
        await apiStore.setItem(`${userTypeName}goals`, context.state[userTypeName].goals);

        return userGoals;
      });

    return goals;
  },
};
